<template>
  <ContentPage title="About" page="about">
    <p>
      SnapInsta is an independent online tool created to make saving publicly accessible Instagram
      content more convenient.
    </p>
    <p>
      Our service allows users to paste an Instagram URL and process available photos, videos, Reels,
      and Stories without creating an account or logging in.
    </p>
    <p>
      We focus on keeping the process simple: copy a link, paste it into SnapInsta, and follow the
      available download options.
    </p>
    <p>
      SnapInsta is not affiliated with Instagram or Meta Platforms, Inc. We do not operate Instagram
      and do not represent ourselves as an official Instagram service.
    </p>
    <p>
      We also believe that content creators and copyright owners should be respected. Users are
      responsible for making sure they have the necessary rights or permission to download and use
      content.
    </p>
    <p>
      If you have a question, report, copyright concern, or other issue related to SnapInsta, please
      visit our <router-link to="/contact/">Contact Us</router-link> page.
    </p>
  </ContentPage>
</template>

<script>
import ContentPage from '@/components/ContentPage.vue';

export default {
  name: 'AboutPage',
  components: {
    ContentPage,
  },
};
</script>
